import { ReviewCard } from "@components/organism";
import { useReviewUser } from "./useReviewUser";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { zafClient } from "@services/Zendesk";

export function ReviewUser() {
    const { selectedUser, info, navigate, handleSave, loading } = useReviewUser();
    
    if (!selectedUser) {
        return (
            <div className="flex align-center p-4">
                <button onClick={() => navigate("/")}><IoArrowBackCircleOutline className="w-10 h-10 cursor-pointer"/></button>
                <p className="p-4 bold">Nenhum usuário selecionado para revisão.</p>
            </div>
        );
    }

    return (
        <ReviewCard
            title="• Editar conta"
            subtitle="Revise os dados da conta:"
            info={info}
            onPrimaryAction={handleSave}
            onSecondaryAction={() => navigate(`/edit-user/${selectedUser.id}`)}
            primaryActionLabel={loading ? 'Salvando' : 'Salvar alterações'}
            headerLabel="Cliente"
            disabled={loading}
            onSeeUser={() => {
                if (!selectedUser?.id) return;
                zafClient.invoke('routeTo', 'user', selectedUser.id);
            }}
        />
    );
}